module.exports = __webpack_public_path__ + "img/blog-goutham.381b8f39.png";